const TermsConfig = {
  links: [
    { name: "Terms & Conditions", url: "/terms" },
  ],

  // ---------- TERMS & CONDITIONS ----------
  terms: {
    title: "Terms & Conditions",
    name: "Terms & Conditions",
        sections: [
      {
        introduction:"Welcome to gsussoftware.in. These Terms and Conditions (“Terms”) govern your access to and use of our website at www.gsussoftware.in (the “Website”). Please read these Terms carefully before using the Website. By accessing or using the Website, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you may not use the Website.",
      
        heading: "1. Use of the Website",
        content: [
          {
            subheading: "Eligibility",
            text: "By using the Website, you affirm that you are at least 18 years old or have reached the age of majority in your jurisdiction and have the legal capacity to enter into these Terms.",
          },
          {
            subheading: "Account",
            text: "Some features of the Website may require you to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.",
          },
          {
            subheading: "Acceptable Use",
            text: "You agree to use the Website for lawful purposes and in compliance with these Terms. You will not engage in any activities that may harm the Website, its users, or interfere with the proper functioning of the Website.",
          },
          {
            subheading: "Prohibited Activities",
            list: [
              "Violating any applicable laws or regulations.",
              "Impersonating any person or entity or falsely claiming an affiliation.",
              "Uploading or transmitting any harmful or malicious content, including viruses or malware.",
              "Engaging in any form of unauthorized data mining or scraping.",
              "Attempting to gain unauthorized access to any part of the Website or its systems.",
              "Interfering with or disrupting the Website’s services or networks.",
            ],
          },
        ],
      },
      {
        heading: "2. Intellectual Property",
        content: [
          {
            subheading: "Content Ownership",
            text: "All content and materials available on the Website, including but not limited to text, graphics, images, videos, logos, and software, are the property of gsussoftware.in or its licensors and are protected by copyright and other intellectual property laws.",
          },
          {
            subheading: "Limited License",
            text: "gsussoftware.in grants you a limited, non-exclusive, non-transferable license to access and use the content on the Website solely for personal and non-commercial purposes. You may not copy, modify, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any content obtained from the Website without our express written permission.",
          },
        ],
      },
      {
        heading: "3. Third-Party Links",
        content: [
          {
            text: "The Website may contain links to third-party websites or services that are not controlled or operated by gsussoftware.in. We are not responsible for the content, practices, or privacy policies of these third-party sites. You access and use such links at your own risk, and we encourage you to review the terms and policies of those websites.",
          },
        ],
      },
      {
        heading: "4. Disclaimer of Warranties",
        content: [
          {
            text: "The Website and its content are provided on an “as-is” basis without any warranties, express or implied. gsussoftware.in disclaims all warranties, including but not limited to warranties of merchantability, fitness for a particular purpose, non-infringement, and accuracy of information. We do not guarantee that the Website will be error-free or continuously available.",
          },
        ],
      },
      {
        heading: "5. Limitation of Liability",
        content: [
          {
            text: "In no event shall gsussoftware.in, its directors, officers, employees, or agents be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Website, even if advised of the possibility of such damages. Your sole remedy for dissatisfaction with the Website is to stop using it.",
          },
        ],
      },
      {
        heading: "6. Indemnification",
        content: [
          {
            text: "You agree to defend, indemnify, and hold gsussoftware.in and its affiliates harmless from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorney’s fees, arising out of or in any way connected with your use of the Website or violation of these Terms.",
          },
        ],
      },
      {
        heading: "7. Modification of Terms",
        content: [
          {
            text: "We reserve the right to modify these Terms at any time, and such changes will be effective upon posting on the Website. Your continued use of the Website after any changes to the Terms indicates your acceptance of the modified Terms.",
          },
        ],
      },
      {
        heading: "8. Termination",
        content: [
          {
            text: "We may terminate or suspend your access to the Website at any time, with or without cause, and without prior notice or liability.",
          },
        ],
      },
      {
        heading: "9. Governing Law",
        content: [
          {
            text: "These Terms shall be governed by and construed in accordance with the laws of Karnataka, India, without regard to its conflicts of laws principles.",
          },
        ],
      },
      {
        heading: "10. Contact Us",
        content: [
          {
            text: "If you have any questions or concerns about these Terms, please contact us at info@gsussoftware.com.",
          },
        ],
      },
    ],
    conclusion:
      "Thank you for reading and accepting our Terms and Conditions. Enjoy using gsussoftware.in!",
  },

};
export default TermsConfig;